import { FC, memo } from 'react';

import { LinkCellProps } from './LinkCell.types';

export const LinkCell: FC<LinkCellProps> = memo((props) => {
    const { name, link } = props;

    return (
        <a href={link} target='_blank' rel='noopener noreferrer'>
            {name}
        </a>
    );
});

export default LinkCell;
